import api from './api'

const productService = {}

productService.getProducts = () => api.get('/cloud/products')

export default productService
